<template>
    <div class="row" v-bind:class="{ 'has-danger' : error !== null, 'form-group': !noFormGroup }">
        <label :class="labelClasses" class="form-control-label  col-form-label" :for="name">{{ labelComputed }}</label>
        <div :class="inputHolderClasses">
            <div class="row">
                <div class="col-6">
                    <input class="form-control" type="text" :name="name" :id="name" v-model="title"/>
                </div>

                <div class="col-6">
                    <multi-select  :name="name + '_display'" :id="name + '_display'" :options="display_options" v-model="title_display"
                                   value="0" :searchable="false" label="name" :allow-empty="false"
                                   :selectedLabel="uLang('app.select')" :selectLabel="uLang('app.press_enter_to_select')"
                                   :deselectLabel="uLang('app.press_enter_to_remove')" :placeholder="uLang('app.select_an_option')"/>
                </div>
            </div>

            <span class="help-block form-control-feedback" v-if="error != null" v-text="error"></span>
        </div>
    </div>
</template>

<script>
    import MultiSelect from 'vue-multiselect'
    import ElementMixin from '~/mixins/element'

    export default {
        name: 'title-with-title-display',

        mixins: [ElementMixin],

        components: {
            'multi-select': MultiSelect,
        },

        props: {
            value: {
                type: Object,
                required: false,
                default: () => {
                    return {
                        title: null,
                        title_display: 0,
                    }
                }
            },
            noFormGroup: {
                type: Boolean,
                required: false,
                default: false,
            },
            labelClasses: {
                type: String,
                required: false,
                default: 'col-md-3 col-xl-2 col-sm-12',
            },
            inputHolderClasses: {
                type: String,
                required: false,
                default: 'col-md-9 col-xl-10 col-sm-12'
            },
        },

        data() {
            return {
                title: null,
                title_display: null,
                display_options: [
                    {
                        name: uLang('app.no'),
                        value: 0,
                    },
                    {
                        name: uLang('app.yes_without_the_name_of_the_candidate'),
                        value: 1,
                    },
                    {
                        name: uLang('app.yes_with_the_name_of_the_candidate_in_front_of_the_title'),
                        value: 2,
                    },
                    {
                        name: uLang('app.yes_with_the_name_of_the_candidate_at_the_back_of_the_title'),
                        value: 3,
                    },
                ],
            };
        },

        created() {
            this.title = this.value.title;
            this.title_display = this.value.title_display;


            this.title_display = this.display_options.find((option) => {
                return option.value == this.value.title_display;
            }) || null;

        },

        computed: {
            compoundProperty() {
                let a = this.title;
                let t = this.title_display;

                return Date.now();
            },
        },

        watch: {
            compoundProperty() {
                this.$emit('input', { title: this.title, title_display: this.title_display.value});
            }
        }
    };
</script>
